<template>

        <button
            :class="choiced ? 'choiced' : 'notChoiced' "
            type="button"
            @click.prevent="addToCart"
            >
            <span v-show='this.load' class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-show='this.load' class="visually-hidden"> Aguarde...</span>
            <span v-show='this.choiced' class="visually-hidden"><i class="fas fa-check"></i></span>
            <span id='span-button'></span>
            <span v-if='!choiced' v-show='!this.load' class="visually-hidden">Adicionar</span>
            <span v-if='choiced' v-show='!this.load' class="visually-hidden">   Adicionado</span>
            

        </button>


</template>

<script>
import {mapActions} from 'vuex'


    export default {
        props: {
            ProductId: {
                type: Number,
            },
            PrecoVenda: {
                type: String,
            },
            User: {
                type: String,
            },
        },
        components: {
        },
        computed: {

        },
        data() {
            return {
                quantidade_produto: 1,
                user:this.User,
                load:false,
                add:false,
                choiced:false
            }
        },

        methods: {
            ...mapActions('product_detail',['ActionAddProductToCart']),
            ...mapActions('pre_cart',['ActionGetPreCart']),
           
             async addToCart (){
                    
                    this.load = !this.load
                    const add =  await this.ActionAddProductToCart({
                     "quantity":this.quantidade_produto, 
                     "price": parseInt(this.PrecoVenda),
                     "user": this.User,
                     "product":this.ProductId
                     
                     })
                    if (add === 'OK') {
                        this.load = !this.load
                        this.choiced = true
                        this.ActionGetPreCart({user:this.User})
                    }
                    if (add === 'ERROR') {
                        alert('Erro ao adicionar produto.')
                    }

             },

        },

    }
</script>

<style lang="css" scoped>

.notChoiced{
    background: var(--main-red-black);
    border: 1px solid var(--main-red-black);
    box-sizing: border-box;
    border-radius: 8px;
    color: var(--main-white);
    font-size: .8rem;
    font-weight: bold;
    padding: .2rem .3rem;
    width: 100%;    
}

.choiced{
    background-color: var(--main-red-light); 
    border-radius: 0.375rem;
    color: var(--main-red-black);
    font-size: .8rem;
    font-weight: bold;
    padding: .2rem .3rem;
    width: 100%;
    text-decoration: none;
}

button {
    background-color: var(--main-red-black); 
    border-radius: 0.375rem;
    color: var(--main-white);
    font-size: .8rem;
    font-weight: bold;
    padding: .2rem .3rem;
    width: 100%;
    text-decoration: none;
}

  @media (min-width: 1400px) and (max-width: 2600px) {

  }

.title_saldo{
  font-family: Roboto;
font-style: normal;
font-weight: 500;
font-size: 1rem;
line-height: 1.2rem;
color: var(--main-red-black);
/* identical to box height */
font-feature-settings: 'cpsp' on;
}

.form{
    left:0;
    bottom:2rem;
    position: initial;
    padding:1rem;
    width: 100%;
}

.add_item{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom:2rem;
}
.q_button{
    display: flex;
}
.quantity{
width: 50%;
}
.quantity h4{
    display:flex;
    justify-content: flex-end;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    text-transform: capitalize;
    margin: 0rem 0rem 0.55rem 0rem;  
}
.price {
width: 50%;
}
.price h5 {
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 1.3rem;
line-height: 28px;
display: flex;
align-items: center;
text-transform: capitalize;
color: var(--main-red-black);
}
.price h3{
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 21px;
text-transform: capitalize; 
color: #2C2C2C;
margin: 0rem 0rem 0.55rem 0rem;  
}

.b_wraper{
    display:flex;
    justify-content: flex-end;
}

.buttons{
  background-color: var(--main-red-black);
  border-radius: 0.375rem;
  color: #fff;
  font-size: 1.2857rem;
  font-weight: bold;
  padding: 0.032rem 0.032rem 0.032rem ;
  width: 32px;
  height:32px;
  
}
.number{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: capitalize;
    color: #3A3A3A;
    padding: 0 1rem ;
}

  @media (min-width: 1400px) and (max-width: 2600px) {
.form{
    display:block;
    position:fixed;

}
.add_item{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin:auto;
    width: 50%;
    margin-bottom:2rem;
}
button[data-v-b3d0df04] {
    background-color: var(--main-red-black);
    border-radius: 0.375rem;
    color: var(--main-white);
    font-size: 1.2857rem;
    font-weight: bold;
    padding: 0.571rem 1rem;
    width: 50%;
    margin-left:25%;
}
  }

</style>